import { useOverlayContainer } from '../hooks';
import React from 'react';
import { ClickDetails, OverlayHighlightDetails } from '@fullstory/page-insights-ui';
import {
  calculateRankIndicatorPositions,
  ClickAreaHighlight,
  RankIndicator,
} from '../../Components';
import { ClickAreaOverlayDisplayOptions } from '../../ClickMaps';
import { SimpleRect } from '@fullstory/util/rect';

export interface ClickAreaOverlayContainerProps {
  /** The playback scale factor (i.e. zoomInverseScale * (frameInverseScale / visualInverseScale) */
  playbackScaleFactor: number;
  /** On rank indicator or zone select */
  onSelect: (rank: number) => void;
  inverseScale: number;
  selectedItem: number;
  clickOverlayDetails: OverlayHighlightDetails[];
  clickDetails: ClickDetails;
  displayOptions: ClickAreaOverlayDisplayOptions;
  layoutViewport: SimpleRect;
}

export const ClickAreaOverlayContainer: React.FC<ClickAreaOverlayContainerProps> = ({
  playbackScaleFactor,
  clickOverlayDetails,
  onSelect,
  selectedItem,
  inverseScale,
  clickDetails,
  displayOptions,
  layoutViewport,
}) => {
  const { hoveringItem, overlayRefs, allOverlayAwareOnHover, onHover } = useOverlayContainer();

  // Reverse since we want lowered number rank indicators (more important ones) above higher numbered ones
  const orderedClientRects = [...clickOverlayDetails];
  orderedClientRects.reverse();

  const rankIndicatorPositions = calculateRankIndicatorPositions(orderedClientRects, inverseScale);

  return (
    <>
      {orderedClientRects.map((clickOverlayDetail, index) => {
        const rank = clickOverlayDetail.rank;
        return (
          <>
            <ClickAreaHighlight
              clickOverlayDetail={clickOverlayDetail}
              selected={selectedItem === rank}
              onSelect={() => onSelect(hoveringItem)}
              hovering={hoveringItem === rank}
              onHover={allOverlayAwareOnHover}
              key={`${rank}-highlight`}
              playbackScaleFactor={playbackScaleFactor}
              totalClicks={clickDetails.totalClicks}
              popoverContent={clickOverlayDetail.elementStats.TooltipLines}
              colorClass={clickOverlayDetail.color}
              ref={element => (overlayRefs.current[rank - 1] = element!)}
            />
            {displayOptions.displayIndicators && (
              <RankIndicator
                rank={rank}
                selected={selectedItem === rank}
                onSelect={() => onSelect(hoveringItem)}
                playbackScaleFactor={playbackScaleFactor}
                clientRect={rankIndicatorPositions[index]!}
                key={`${rank}-rankindicator`}
                hovering={hoveringItem === rank}
                setHovering={onHover}
                layoutViewport={layoutViewport}
              />
            )}
          </>
        );
      })}
    </>
  );
};
